var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/testimonial_css';
let Testimonial = class Testimonial extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.aim = '';
        this.image = '';
        this.name = '';
        this.job = '';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    firstUpdated() {
        const gs1TestimonialQuoteContainer = this.shadowRoot.querySelector('.testimonial blockquote');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1TestimonialQuoteContainer.appendChild(item);
            }
        });
    }
    render() {
        return html `
      ${env.debug
            ? html `<link rel="stylesheet" href="${env.baseUrl}/css/testimonial.css" />`
            : html ``}
      <div class="testimonial ${this.type}">
        <figure class="testimonial__inner">
          ${this.type == '' && this.image != ''
            ? html `<img src=${this.image} alt="image" />`
            : html ``}
          <div>
            <blockquote>
              ${this.type == ''
            ? html `<div class="quote-marks">
                    <gs1-fa-icon
                      family="fas"
                      type="fa-quote-left"
                    ></gs1-fa-icon>
                  </div>`
            : html ``}
            </blockquote>
            <footer>
              ${this.type == 'is-block' && this.image != ''
            ? html `<img src=${this.image} alt="image" />`
            : html ``}
              <figcaption>
                <cite>${this.name}</cite>
                <dt>${this.job}</dt>
              </figcaption>
            </footer>
          </div>
        </figure>
        ${this.type == 'is-block'
            ? html `<div class="quote-marks">
              <gs1-fa-icon family="fas" type="fa-quote-left"></gs1-fa-icon>
            </div>`
            : html ``}
      </div>
    `;
    }
};
__decorate([
    property()
], Testimonial.prototype, "type", void 0);
__decorate([
    property({ reflect: true })
], Testimonial.prototype, "aim", void 0);
__decorate([
    property()
], Testimonial.prototype, "image", void 0);
__decorate([
    property()
], Testimonial.prototype, "name", void 0);
__decorate([
    property()
], Testimonial.prototype, "job", void 0);
Testimonial = __decorate([
    customElement('gs1-testimonial')
], Testimonial);
export { Testimonial };
//# sourceMappingURL=testimonial.js.map